import { Box, Divider, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import FGlogo from 'images/family-golf-logo.svg'
import RouterLinkButton from 'components/router-link-button'
import { LandingButtonExternal, LandingContainer } from 'components/signup-util'
import RequirementAlert from 'components/programs/list/requirement-alert'
import { useLocation } from 'react-router-dom'
import useBrand from 'components/use-brand'
import { REQUEST_STATUS, statusDescription } from 'lib/signup-utils'
import * as routes from 'lib/family-cup-utils/routes'

const useStyles = makeStyles(theme => ({
  signupHeading: {
    textAlign: 'center',
    marginBottom: theme.spacing(4),
    fontSize: 30,
    fontWeight: 'bold',
  },
}))

function Landing() {
  const classes = useStyles()
  const location = useLocation()
  const { title } = useBrand()
  const searchParams = new URLSearchParams(location.search)

  const requestStatus = searchParams.get('lpga-status')
  const isApproved =
    requestStatus?.toLowerCase() === REQUEST_STATUS.APPROVED.toLowerCase()

  const lpgaSignUpLink =
    requestStatus && !isApproved
      ? routes.signupLpgaRequest()
      : routes.signupLpga()

  const description = statusDescription(title)

  return (
    <LandingContainer>
      {searchParams.get('signupRequired') && (
        <RequirementAlert severity="error">
          Please use one of the buttons below to sign up for Family Golf.
        </RequirementAlert>
      )}
      {!isApproved && requestStatus && description[requestStatus] && (
        <RequirementAlert severity={description[requestStatus].severity}>
          {description[requestStatus].text}
        </RequirementAlert>
      )}
      <Box p={4}>
        <img
          src={FGlogo}
          alt="Family Golf Logo"
          style={{ height: 96, width: 215 }}
        />
      </Box>
      <Box mb={5}>
        <Typography
          variant="h5"
          component="h2"
          gutterBottom
          className={classes.signupHeading}
        >
          Become a Family Golf Coach
        </Typography>
        <Typography variant="body1" color="textSecondary" gutterBottom>
          Create a community at your facility by turning golf into a
          multi-generational team sport.
        </Typography>
      </Box>
      <Grid container spacing={2} direction="column">
        <LandingButtonExternal location="/family-golf-signup/signup">
          PGA Members, Associates, or Students
        </LandingButtonExternal>
        <LandingButtonExternal location={lpgaSignUpLink}>
          LPGA Members
        </LandingButtonExternal>
        <Grid item>
          <Box pt={4} pb={3}>
            <Divider />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box display="flex" flexDirection="column" alignItems="center">
            <Typography variant="body1">Already have an account?</Typography>
            <RouterLinkButton color="primary" to={'/family-golf'}>
              Login
            </RouterLinkButton>
          </Box>
        </Grid>
      </Grid>
    </LandingContainer>
  )
}

export default Landing
